import React, { useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { RoomTemplateData, getRoomTemplateQuery, ActionButtons } from "./details-page";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { useAuthDataContext } from "components/auth";
import { deleteRoomTemplateMutation } from "./table";

const RoomTemplateDetailsPage = ({
  match: {
    params: { id, contractId },
  },
  history,
}) => {
  const { hasAdminPrivileges } = useAuthDataContext();
  const { currentCustomerId } = useCurrentCustomerContext();
  const query = useMemo(
    () => getRoomTemplateQuery({ roomTemplateId: id, customerId: currentCustomerId, contractId, hasAdminPrivileges }),
    [contractId, currentCustomerId, id, hasAdminPrivileges],
  );
  const { data, loading, error } = useQuery(query);
  const roomTemplate = data.roomTemplate;

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={roomTemplate}>
        <PageHeaderBar
          showBackButton
          title="app.page.roomTemplate.details.title"
          titleParams={{ roomTemplateName: roomTemplate ? roomTemplate.codename : null }}
          buttons={
            <ActionButtons
              id={id}
              contractId={contractId}
              customerId={currentCustomerId}
              name={roomTemplate ? roomTemplate.codename : ""}
              mutation={deleteRoomTemplateMutation}
              history={history}
            />
          }
        />
        <PageSection>
          <RoomTemplateData roomTemplate={roomTemplate} />
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default RoomTemplateDetailsPage;
